import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Se un chunk JS non si carica (build vecchia in cache dopo un deploy),
    // ricarica una sola volta per prendere l'ultima versione.
    const msg = String(error?.message || error || "");
    const isChunkError = /ChunkLoadError|Loading chunk|dynamically imported module/i.test(msg);
    if (isChunkError && !sessionStorage.getItem("ag_chunk_reloaded")) {
      sessionStorage.setItem("ag_chunk_reloaded", "1");
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "18px",
            background: "#09090b",
            color: "#fafafa",
            fontFamily: "system-ui, sans-serif",
            textAlign: "center",
            padding: "24px",
          }}
        >
          <div style={{ background: "#eab308", padding: "12px", borderRadius: "2px" }}>
            <span style={{ color: "#000", fontWeight: 800, fontSize: "20px", letterSpacing: "0.05em" }}>
              ALEX GOLD
            </span>
          </div>
          <h1 style={{ fontSize: "22px", fontWeight: 800, margin: 0 }}>
            Un attimo, ci siamo quasi
          </h1>
          <p style={{ color: "#a1a1aa", maxWidth: "420px", margin: 0, lineHeight: 1.5 }}>
            Stiamo caricando l'ultima versione della pagina. Se non si carica da sola,
            tocca il pulsante qui sotto.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => {
              sessionStorage.removeItem("ag_chunk_reloaded");
              window.location.reload();
            }}
            style={{
              background: "#eab308",
              color: "#000",
              border: "none",
              padding: "14px 28px",
              fontSize: "15px",
              fontWeight: 700,
              borderRadius: "999px",
              cursor: "pointer",
            }}
          >
            Ricarica la pagina
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
